<template>
  <v-snackbar
    v-model="show"
    bottom
    right
    :color="notification.color"
    :timeout="notification.timeout"
    >
    {{ notification.message }}
    <v-flex justify-end>
      <v-btn
        flat
        v-if="notification.url"
        :to="notification.url"
        @click="hideSnackbar">Go to</v-btn>
      <v-btn
        flat
        @click="hideSnackbar"
      >
        Close
      </v-btn>
    </v-flex>
  </v-snackbar>
</template>
<script>
import { CLEAR_NOTIFICATION } from '@/store/actions/common'
export default {
  name: "NotificationBar",
  data() {
    return {
      show: false,
    }
  },
  created() {
    this.$store.watch(state => state.common.notification, () => {
        this.show = true
    })
  },
  computed: {
    notification() {
      return this.$store.state.common.notification
    }
  },
  methods: {
    hideSnackbar() {
      this.show = false
      this.$store.dispatch(CLEAR_NOTIFICATION, this.notification.id)
    },
  }
}
</script>

